import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import { fetchTeamMetrics } from '../../../../../../api/MetricsService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter } from '../../../utils';
import { formatNumber } from '../../../../../../api/PerformanceFeedback';

import BannerLayout from '../../../layouts/banner';

import {
  FormulaName,
  FormulaValue
} from '../../../components/ui';

class GrossMarginsStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      sellingPrice: 0,
      unitCost: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      teamsEndpoint()
    ).then(res => {

      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Gross margin fail").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      Promise.all([
        fetchTeamMetrics(team_id, roundId),
        getRequest(`${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}&team_id=${team_id}`),
      ])
        .then(res => {
          const metrics = res[0];
          const currentRoundMetrics = metrics.find(i => Number(i.round_number) === Number(activeRound));

          const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
          const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
          const sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;

          const incomeStatement = res[1].body;
          const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
          const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
          const unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            sellingPrice,
            unitCost,
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      sellingPrice,
      unitCost
    } = this.state;

    const { previousShownErrors, gamesTargets } = this.props;

    const grossMargin = Number(gamesTargets[0].gross_margin || 0);

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Gross Margins"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams generated insufficient margins`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <p>The gross profit spread between these team’s product’s average selling price ${sellingPrice.toFixed(2)} and the average cost to manufacture each unit ${(unitCost).toFixed(2)} was ${(sellingPrice - unitCost).toFixed(2)}, which was not enough to generate the gross profit margin needed to hit the <b>{Number((grossMargin * 100).toFixed(2))}%</b> gross margin target.</p>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#FEC665" color="rgba(0, 27, 59, 0.94)">
              Gross Profit Margin<br />
              Per Unit of Sale
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Selling Price - Unit Cost
              <span className='divider' />
              Selling Price
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              {formatNumber(sellingPrice - unitCost)}
              <span className='divider' />
              {formatNumber(sellingPrice)}
            </FormulaValue>
          </Fragment>
        )
        }
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#FBEDD5',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default GrossMarginsStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/gross-margins/step2.js